import React, { Component } from 'react';
class Followers extends Component {
    constructor() {
        super();
        this.showEmployeeList = this.showEmployeeList.bind(this);
    }
    showEmployeeList(k,item,postType) {
        var all_user_list = this.props.all_user_list;
        var loggedin_user = this.props.loggedInUser;
        if(this.props.relationType == "Followers"){
            var emp_id = item.user_id;
        }else{
            var emp_id = item.follower_id;
        }
        return(<div class="follow-unfollow-box">
                <div class="left-item">
                    <div class="img-box">
                        <a name="max" target="_blank" href={`/viewEmployee/${emp_id}`}>
                            {all_user_list[emp_id].profile_image ?
                                        <img src={all_user_list[emp_id].profile_image} />
                                        :
                        <div class="firstletter-box">{all_user_list[emp_id].name.charAt(0).toUpperCase()}</div>
                            }
                        </a>
                    </div>
                    <div class="name-desig">
                        <div class="name">
                            <a href={`/viewEmployee/${emp_id}`}>{all_user_list[emp_id].name}</a>
                        </div>
                        <div class="desig">{all_user_list[emp_id].position}</div>
                    </div>
                </div>
                <div class={`right-item ${item.btn_show}`}>
                    <button class={item.btn_cls} onClick={(e) =>this.props.parent.followUser(e,loggedin_user,emp_id,postType,item.btn_value,k,this.props.relationType)}>{item.btn_value}</button>
                </div>
            </div>)
    }
    render() {
        return(
                <div class="followup_popup">
                    <div class="modal fade" id="add-followup" tabindex="-1" role="dialog" aria-labelledby="Deal" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="top-head">
                                        <div class="top-text">{this.props.relationType}</div>
                                    </div>
                                    <button type="button" class="close" data-dismiss="modal">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 5L5 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5 5L15 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>                                                                                
                                    </button>
                                </div>
                
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="followup-tab">
                                                <ul class="nav nav-tabs">
                                                    <li class="active">
                                                        <a data-toggle="tab" href="#flow2" onClick={(e) => this.props.parent.resetSearchBox(e, 'flow1')}>
                                                            Work
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a data-toggle="tab" href="#flow1" onClick={(e) => this.props.parent.resetSearchBox(e, 'flow2')}>
                                                            Life
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="followuptab-details">
                                            <div class="tab-content">
                                                <div id="flow1" class="tab-pane fade ">
                                                    <div class="search-box">
                                                        <input type="text" placeholder="Search" class="input-cls" id="flow1_srch" value={this.props.flowoneval} name="srch_emp" onChange={this.props.parent.findBolEmployee.bind(this, this.props.relationType, 2, "flow1")} />
                                                        <span>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#5A738E" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M14.0001 14.0001L11.1001 11.1001" stroke="#5A738E" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                                                            </svg>                                                
                                                        </span>
                                                    </div>
                                                        {this.props.followerDataCount > 0 ?
                                                    <div class="followunfollow-full-box">
                                                                    {this.props.followerData && this.props.followerData.map((item,key) =>
                                                                        item.follow_relation_type == 2 ?
                                                                        this.showEmployeeList(key,item,2):""
                                                                        )}
                                                                            </div>
                                                        : "No Data found !!!"}
                                                                            </div>
                                                <div id="flow2" class="tab-pane fade in active">
                                                    <div class="search-box">
                                                        <input type="text" placeholder="Search" class="input-cls" id="flow2_srch" value={this.props.flowtwoval} onChange={this.props.parent.findBolEmployee.bind(this, this.props.relationType, 1, "flow2")} />
                                                        <span>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#5A738E" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M14.0001 14.0001L11.1001 11.1001" stroke="#5A738E" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                                                            </svg>                                                
                                                        </span>
                                                    </div>
                                                    {this.props.followerDataCount > 0 ?
                                                        <div class="followunfollow-full-box">
                                                        {this.props.followerData.map((item,key) =>
                                                                item.follow_relation_type == 1 ?
                                                                    this.showEmployeeList(key,item,1) : "")}
                                                                        </div>
                                                    : "No data found !!!"}
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                )
    }
}
export default Followers;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/follower.js